import { Button } from "components/Button/Button";
import { FileInput } from "components/FileInput/FileInput";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { importPeriodInit } from "./api";

interface props {
  showForm?: () => any;
  reload?: () => any;
}
export const ImportForm = ({ showForm, reload }: props) => {
  const [resetForm, setResetForm] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<any>();
  const [customerData, setCustomerData] = useState<any>();


  const handleSelectedFile = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      // setSelectedFile(e.target.files[0]);
      setSelectedFile({
        url: URL.createObjectURL([...e.target.files][0]),
        file: [...e.target.files][0],
      });
    }
  };
  async function sendDataToServer(event) {
    event.preventDefault();
    try {
        var data = new FormData();
        data.append("file", selectedFile?.file);
        const res = await importPeriodInit(data,JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id,JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id)
        reload&&reload()
    } catch (error:any) {
        setResponse(error.response?.data)
    }
  }

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  return (
    <>
      <div className="col-lg-12 mb-1">
        <div className="card ">
          <div className="card-body">
            <form className="row d-flex flex-row" onSubmit={sendDataToServer}>
              <div className="row">
 <div className="col-12 col-sm-5  col-md-3">
                  <Textbox
                  textboxName="Warehouse"
                  textboxType="text"
                  labelText="warehouse"
                  defaultValue={JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Name}
                  mode={'view'}
                  />
                </div>

                {(
                  JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id) && (
                  <div className="col-md-3 col-sm-5 col-12 ">
                      <Textbox
                  textboxName="warehousedetail"
                  textboxType="text"
                  labelText="warehousedetail"
                  defaultValue={JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Name}
                  mode={'view'}
                  />
                  </div>
                )}

                <div className="col-lg-4 col-12 col-sm-9 ">
                  <FileInput
                    maxSize={25600000}
                    lable="PeriodInit"
                    name="PeriodInit"
                    file={selectedFile}
                    onChange={handleSelectedFile}
                    hideSrc={true}
                    accept=".xls, .xlsx"
                  />
                </div>
              </div>
              <div className="col-lg-12 mt-1 btns_form">
                <Button value="confirm" btnType="submit" />
                <Button
                  btnType="cancel"
                  value="Cancel"
                  onClick={() => {
                    setResetForm(true);
                    showForm && showForm();
                  }}
                />
              </div>
            </form>
       
          </div>
        </div>
      </div>
    </>
  );
};
